// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NavLink_links__3eCDX {\n    font-size: 18px;\n}", "",{"version":3,"sources":["webpack://src/components/NavLink.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB","sourcesContent":[".links {\n    font-size: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"links": "NavLink_links__3eCDX"
};
export default ___CSS_LOADER_EXPORT___;
